<template>
  <v-card>
    <v-card-text>
      <v-container grid-list-lg class="pa-0 ma-0" :style="{ width: '100% !important' }">
        <v-layout wrap>
          <v-flex xs12 sm6 md4 lg3 class="form-control">
            <label>{{ $t('channel') }}</label>
            <multiselect
              v-model="form.channel"
              :options="channelOptions"
              track-by="value"
              label="text"
              :show-labels="false"
              :allow-empty="false"
              :searchable="false"
            />
          </v-flex>
          <v-flex v-for="(items, key) in options" :key="key" xs12 sm6 md4 lg3 class="form-control">
            <label>{{ $t(key) }}</label>
            <multiselect
              v-model="form[key]"
              :options="items"
              track-by="value"
              label="text"
              :show-labels="false"
              :allow-empty="false"
              :searchable="false"
            />
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="form-control">
            <label>{{ $t('Start date') }}</label>
            <datepicker
              v-model="form.start_date"
              :placeholder="$t('from')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="form.start_date = $event"
            />
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="form-control">
            <label>{{ $t('End date') }}</label>
            <datepicker
              v-model="form.end_date"
              :placeholder="$t('to')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="form.end_date = $event"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="handleClear">
        {{ $t('Clear Search') }}
      </v-btn>
      <v-btn color="primary" @click="handleSubmit">
        <v-icon>search</v-icon>
        {{ $t('Search') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'

export default {
  components: { Multiselect, datepicker },
  inject: ['filters', 'setFilters', 'survey'],
  data() {
    return {
      form: {
        ...this.filters()
      },
      channelOptions: [
        { value: 'all', text: this.$t('All') },
        { value: 'line', text: 'LINE' },
        { value: 'facebook', text: 'Facebook' },
        { value: 'email', text: 'Email' },
        { value: 'sms', text: 'SMS' }
      ]
    }
  },
  computed: {
    options() {
      return Object.entries(this.survey().filter_json).reduce((prev, [key, values]) => {
        prev[key] = [
          { value: 'all', text: this.$t('All') },
          ...values.map((value) => ({ value: value, text: value }))
        ]
        return prev
      }, {})
    }
  },
  methods: {
    handleSubmit() {
      this.setFilters({ ...this.form })
    },
    handleClear() {
      this.form = {
        channel: { value: 'all', text: this.$t('All') },
        ...Object.keys(this.options).reduce((prev, key) => {
          prev[key] = { value: 'all', text: this.$t('All') }
          return prev
        }, {}),
        start_date: null,
        end_date: null
      }
      this.setFilters({ ...this.form })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/Survey/SurveyAdvancedSearch.vue